import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsProject } from 'types/cms/collection-types'
import { stringify } from 'qs'

/**
 * Get the project from the CMS for the given slug
 *
 * @param {string} slug
 * @param {Language} locale
 * @returns {Promise<CmsProject | undefined>}
 */
const getProjectBySlug = async (slug: string, locale: Language = Language.DUTCH): Promise<CmsProject | undefined> => {
  try {
    const query = stringify({
      locale
    })

    const {
      data: { data }
    } = await axios.get<CMSApiResponseBody<CmsProject>>(`${process.env.CMS_API_URL}/project/${slug}?${query}`)

    return data
  } catch (_) {
    return undefined
  }
}

export default getProjectBySlug
